import { render, staticRenderFns } from "./simple_keyboard_order.vue?vue&type=template&id=4a67928c&scoped=true"
import script from "./simple_keyboard_order.vue?vue&type=script&lang=js"
export * from "./simple_keyboard_order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a67928c",
  null
  
)

export default component.exports